import type { ReactNode } from 'react';

/**
 * The TABITA mark: a dove carrying an olive branch over a cross, set in a
 * "T" — Tabitha (Acts 9) was known for the care she gave her community, and
 * a dove is the plainest way to carry that without literally drawing a
 * person. The source art (`logo-tabita.png`) is the full lock-up with the
 * wordmark; `logo-mark-icon.png` is a pre-cropped, pre-squared 256px export
 * of just the mark, generated once rather than cropped at render time, so
 * every call site — the header at 28px, an auth page at 40px — pays for one
 * small image instead of scaling the 1.4MB original down in the browser.
 */
export function LogoMark({ size = 28 }: { size?: number }): ReactNode {
  return (
    <img src="/logo-mark-icon.png" width={size} height={size} alt="TABITA" className="logo-mark" />
  );
}
